module.exports = __webpack_public_path__ + "img/mapa.dbdf9045.png";